(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('communication-topic-category', {
            parent: 'entity',
            url: '/communication-topic-category?page&sort&search',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.communicationTopicCategory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/communication-topic-category/communication-topic-categorys.html',
                    controller: 'CommunicationTopicCategoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communicationTopicCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('communication-topic-category-detail', {
            parent: 'entity',
            url: '/communication-topic-category/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.communicationTopicCategory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/communication-topic-category/communication-topic-category-detail.html',
                    controller: 'CommunicationTopicCategoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communicationTopicCategory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CommunicationTopicCategory', function($stateParams, CommunicationTopicCategory) {
                    return CommunicationTopicCategory.get({id : $stateParams.id});
                }]
            }
        })
        .state('communication-topic-category.new', {
            parent: 'communication-topic-category',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/communication-topic-category/communication-topic-category-dialog.html',
                    controller: 'CommunicationTopicCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                label: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('communication-topic-category', null, { reload: true });
                }, function() {
                    $state.go('communication-topic-category');
                });
            }]
        })
        .state('communication-topic-category.edit', {
            parent: 'communication-topic-category',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/communication-topic-category/communication-topic-category-dialog.html',
                    controller: 'CommunicationTopicCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CommunicationTopicCategory', function(CommunicationTopicCategory) {
                            return CommunicationTopicCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('communication-topic-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('communication-topic-category.delete', {
            parent: 'communication-topic-category',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/communication-topic-category/communication-topic-category-delete-dialog.html',
                    controller: 'CommunicationTopicCategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CommunicationTopicCategory', function(CommunicationTopicCategory) {
                            return CommunicationTopicCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('communication-topic-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
